import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

export function StatusDot({ tone = "success", pulse = true, className }) {
  const tones = {
    success: "bg-emerald-500",
    warning: "bg-amber-500",
    danger: "bg-red-500",
    idle: "bg-slate-500",
    primary: "bg-blue-500",
  };
  return (
    <span className={cn("relative inline-flex h-2.5 w-2.5", className)}>
      {pulse && (
        <span className={cn("absolute inline-flex h-full w-full rounded-full opacity-60 ngx-pulse", tones[tone])} />
      )}
      <span className={cn("relative inline-flex h-2.5 w-2.5 rounded-full", tones[tone])} />
    </span>
  );
}

export function StatusRow({ label, value, tone = "success", testid }) {
  return (
    <div className="flex items-center justify-between py-2.5 border-b border-slate-800/70 last:border-0" data-testid={testid}>
      <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</span>
      <span className="flex items-center gap-2">
        <StatusDot tone={tone} pulse={tone === "success" || tone === "primary"} />
        <span className="text-sm font-mono text-slate-100">{value}</span>
      </span>
    </div>
  );
}

export function Card({ children, className, ...props }) {
  return (
    <div className={cn("bg-[#0A1128] border border-slate-800 rounded-md", className)} {...props}>
      {children}
    </div>
  );
}

export function SectionTitle({ children, sub }) {
  return (
    <div className="mb-1">
      <h1 className="font-display text-2xl font-bold tracking-tight text-slate-50">{children}</h1>
      {sub && <p className="text-sm text-slate-400 mt-1">{sub}</p>}
    </div>
  );
}

const CAT_TONES = {
  SYSTEM: "text-slate-300", CONNECTOR: "text-cyan-400", TASK: "text-blue-400",
  VISION: "text-indigo-400", AI: "text-violet-400", NGX: "text-amber-400",
  ACTION: "text-emerald-400", HUMAN: "text-blue-300", WARNING: "text-amber-400",
  SAFETY: "text-red-400",
};
export function catColor(cat) { return CAT_TONES[cat] || "text-slate-300"; }

export function LearnLink({ to, label = "Learn", testid }) {
  return (
    <Link to={to} data-testid={testid}
      className="inline-flex items-center gap-1 text-[11px] font-medium text-blue-400 hover:text-blue-300 transition-colors">
      <GraduationCap className="h-3.5 w-3.5" /> {label}
    </Link>
  );
}
